export const CACHE_TIMEOUTS = {
	1: 1 * 60 * 60 * 1000, // 1 hour
	2: 2 * 60 * 60 * 1000, // 2 hours
	3: 4 * 60 * 60 * 1000, // 4 hours
	4: 24 * 60 * 60 * 1000 // 24 hours
};

export const isCacheExpired = (timeStamp, timeoutKey) => {
	const timeoutValues = Object.values(CACHE_TIMEOUTS);
	const timeout = timeoutValues[timeoutKey - 1];

	if (timeout === undefined) {
		throw new Error(`Invalid timeout key: ${timeoutKey}`);
	}

	return !timeStamp || timeStamp < Date.now() - timeout;
};
